<template>
    <v-container fluid style="padding: 0px !important">
        <ProdutoDescri v-if="visualizacao == 'produtos'"></ProdutoDescri>
    </v-container>
</template>

<style scope>
@media (min-device-width: 300px) and (max-device-width: 819px) {
    .paddigMobile {
    padding: 0px 10px !important;
  }

}

.StyleButton {
    background-color: #ff770fe0 !important;
    color: #fff !important;
    font-family: 'Poppins';
    border-radius: 50px;
    margin-top: 20px;
}

.borderGenerator {
    /* box-shadow: 0px 1px 3px 3px rgba(0,0,0,0.35);
     */
    border: 1px solid #bebebe;

}
</style>

<script>

import produtoDescri from "../components/produtoDescri.vue";
import ProdutoDescri from "../components/produtoDescri.vue";

export default {
    name: "anuncio",

    components: { produtoDescri, ProdutoDescri },
    data: () => ({
        visualizacao: "imovel"
    }),
    mounted() {
        window.scrollTo(0, 0);
        if (this.$route.params.strCategoria) {
            this.visualizacao = this.$route.params.strCategoria
        }
    },
}
</script>